import Axios from "axios";

export default {
  getVendor(identification) {
    return Axios.get(
      "/getVendor?identification=" + identification
    );
  }
}